import React from "react";
import { AddressManager } from "@/components/AddressManager";

export default function AddressesPage() {
  return (
    <div data-testid="addresses-page" className="max-w-4xl mx-auto px-4 py-6">
      <AddressManager endpoint="/me/addresses" title="My addresses" />
    </div>
  );
}
